import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormGroup, FormLabel, InputGroup } from 'react-bootstrap';
import * as R from 'ramda';

const propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    invalid: PropTypes.bool,
    className: PropTypes.string,
    errorMessage: PropTypes.string,
};
const defaultProps = {
    placeholder: '',
    value: '',
    className: undefined,
    label: undefined,
    errorMessage: undefined,
    disabled: false,
    required: false,
    invalid: false,
};

function doFormatNumber(value) {
    let whole;
    let decimal;
    let split;
    let next = value;

    if (!next) {
        next = R.is(Number, next) ? next : undefined;
        return next;
    }
    next = String(next);
    if (next.indexOf('.') !== -1) {
        // If the user entered their own decimal we use their placement.
        split = next.split('.');
        whole = split[0] ? split[0].replace(/[^0-9]/g, '') : 0;
        decimal = split[1].padEnd(2, 0);
    } else {
        whole = next.replace(/[^0-9]/g, '');
        decimal = '00';
    }
    return doUnformatNumber(`${whole}.${decimal}`);
}

function doUnformatNumber(value) {
    let next = value;
    if (next) {
        next = String(next);
        return next.replace(/(?!\.)([^0-9])/g, '');
    }
    return R.is(Number, next) ? next : undefined;
}

const valueIntlFormat = Intl.NumberFormat('en-US', { style: 'decimal' });

function MoneyInput(props) {
    const { id, name, value, placeholder, label, onChange, disabled, required, className, invalid, errorMessage } =
        props;

    const stringValue = useMemo(() => {
        if (R.is(Number, value)) {
            return doFormatNumber(value);
        }
        return value;
    }, [value]);
    return (
        <FormGroup>
            {label && (
                <FormLabel htmlFor={id} className={invalid ? 'invalid-insurance-field field-required' : className}>
                    {label}
                </FormLabel>
            )}
            <InputGroup>
                <InputGroup.Prepend>
                    <InputGroup.Text>$</InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                    required={required}
                    id={id}
                    name={name}
                    disabled={disabled}
                    type="text"
                    placeholder={placeholder}
                    onChange={(event) => {
                        event.preventDefault();
                        onChange({
                            ...event,
                            target: { ...event.target, value: doUnformatNumber(event.target.value) },
                        });
                    }}
                    onBlur={(event) => {
                        event.preventDefault();
                        onChange({
                            ...event,
                            target: {
                                ...event.target,
                                value:
                                    event.target.value.trim() !== ''
                                        ? valueIntlFormat.format(doFormatNumber(event.target.value))
                                        : '0.00',
                            },
                        });
                    }}
                    value={stringValue}
                    className={invalid && 'invalid-insurance-form'}
                />
            </InputGroup>
            {invalid ? <span className="error-message-insurance">{errorMessage}</span> : null}
        </FormGroup>
    );
}

MoneyInput.propTypes = propTypes;
MoneyInput.defaultProps = defaultProps;

export default MoneyInput;
